import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import CurrencyPicker from "../../components/currencyPicker/CurrencyPicker";
import NumberField from "../../components/numberField/NumberField";
import type { Currency } from "../../data/BaseEntity";

interface Props {
  currency: Currency;
  exchangeRate: number | undefined;
  disabled?: boolean;
  readonly?: boolean;
  onCurrencyChange: (currency: Currency) => void;
  onExchangeRateChange: (exchangeRate: number | undefined) => void;
}

const OrderCurrency: FC<Props> = ({
  currency,
  exchangeRate,
  readonly,
  disabled,
  onCurrencyChange,
  onExchangeRateChange,
}) => {
  return (
    <Stack>
      <Typography
        variant="h6"
        sx={{
          marginTop: "8px",
        }}
      >
        Waluta
      </Typography>
      <Stack direction="row" spacing={1}>
        <CurrencyPicker
          value={currency}
          readonly={readonly}
          disabled={disabled}
          onChange={(v) => onCurrencyChange(v)}
        />
        <NumberField
          value={exchangeRate}
          size="small"
          label="Kurs EUR/PLN"
          readonly={readonly}
          disabled={disabled}
          onChange={(v) => onExchangeRateChange(v ?? undefined)}
        />
      </Stack>
    </Stack>
  );
};

export default OrderCurrency;
